import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';

import useStyles from './useStyles';

const ToastBody = ({ children, ...rest }) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.wrenchToastBody} {...rest}>
      {children}
    </div>
  );
};

ToastBody.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ToastBody;
